import { render, staticRenderFns } from "./ValidationButton.vue?vue&type=template&id=2ac8c7c9&scoped=true"
import script from "./ValidationButton.vue?vue&type=script&lang=js"
export * from "./ValidationButton.vue?vue&type=script&lang=js"
import style0 from "./ValidationButton.vue?vue&type=style&index=0&id=2ac8c7c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac8c7c9",
  null
  
)

export default component.exports